import { EnRoles } from '@/interfaces/Roles';
import { ItemType } from 'antd/es/menu/interface';
import { Session } from '@inhouse-market/sdk';

export interface MenuItem {
    key: string;
    label: string;
    path?: string;
    icon?: React.ReactNode;
    children?: MenuItem[];
    flag?: string;
}

type RawMenuItem = {
    key: string;
    label: string;
    icon?: React.ReactNode;
    path?: string;
    roles?: EnRoles[];
    children?: RawMenuItem[];
};

export function buildMenu(
    raw: RawMenuItem[],
    user: Session.Role[],
): ItemType[] {
    const userRoles = user.map((r) => r.type);

    const canView = (item: RawMenuItem) => {
        if (!item.roles) return true;

        return item.roles.some((role) => userRoles.includes(role));
    };

    const convert = (items: RawMenuItem[]): ItemType[] =>
        items.filter(canView).map((item) => ({
            key: item.key,
            icon: item.icon,
            label: item.label,
            path: item.path,
            ...(item.children ? { children: convert(item.children) } : {}),
        }));

    return convert(raw);
}
